import { JetView } from 'webix-jet';
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Table for the "Reporte de Depósitos por Franquicias" report.
 * @extends JetView 
 */

export default class TableDepositReportFranchiseView extends JetView {
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format from app config
        var vthis = this; // Reference to the current instance

        // Footer sum for the grouped summary treetable
        webix.ui.datafilter.summTreeColumnFranchise = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    var resultFormat =
                        value.columnId === 'AmountDeposits'
                            ? webix.i18n.priceFormat(result)
                            : webix.i18n.intFormat(result);
                    node.firstChild.innerHTML = resultFormat; // Update the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn,
        );

        return {
            rows: [
                {
                    view: 'multiview',
                    id: 'reportMultiviewFranchise',
                    cells: [
                        {
                            type: 'wide',
                            scrollY: true,
                            view: 'treetable',
                            id: 'datatableFranchiseSummary', // ID for the grouped summary treetable
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            columns: [
                                {
                                    id: 'ProductName',
                                    header: _('Franquicia / Pasarela'), // Column for the Partner/Country/Franchise group label
                                    minWidth: 0,
                                    width: 250,
                                    template: function (obj, common) {
                                        if (obj.$group) {
                                            const label =
                                                obj.$level === 3 ? "<b>" + obj.value + '</b>' : obj.value;
                                            return common.treetable(obj, common) + label;
                                        }
                                        return obj.ProductName;
                                    },
                                },
                                {
                                    id: 'TotalDeposits',
                                    header: _('Cantidad de Depósitos'), // Column for deposit count
                                    width: 170,
                                    footer: { content: 'summTreeColumnFranchise' },
                                    template: function (obj) {
                                        const formatted = webix.i18n.intFormat(obj.TotalDeposits);
                                        return obj.$group && obj.$level === 3 ? '<b>' + formatted + '</b>' : formatted;
                                    },
                                },
                                {
                                    id: 'TotalUniqueUsers',
                                    header: _('Cantidad de Usuarios'), // Column for unique user count
                                    width: 170,
                                    footer: { content: 'summTreeColumnFranchise' },
                                    template: function (obj) {
                                        const formatted = webix.i18n.intFormat(obj.TotalUniqueUsers);
                                        return obj.$group && obj.$level === 3 ? '<b>' + formatted + '</b>' : formatted;
                                    },
                                },
                                {
                                    id: 'AmountDeposits',
                                    header: _('Valor'), // Column for total deposited amount
                                    width: 150,
                                    exportType: 'number',
                                    footer: { content: 'summTreeColumnFranchise' },
                                    template: function (obj) {
                                        const formatted = webix.i18n.priceFormat(obj.AmountDeposits);
                                        return obj.$group && obj.$level === 3 ? '<b>' + formatted + '</b>' : formatted;
                                    },
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div class='container-preload'><div class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            tooltip: true, // Enable tooltips
                            footer: false, // Footer is toggled on after the first successful load
                            math: true, // Enable math calculations
                            pager: { size: 10000, id: 'pagerFranchiseSummary' }, // Pager size
                        },
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatableFranchiseDetail', // ID for the flat detail datatable
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            columns: [
                                { id: 'DepositId', header: 'ID', width: 90 }, // Column for Deposit ID
                                { id: 'UserId', header: _('ID Usuario'), width: 100 }, // Column for User ID
                                {
                                    id: 'CreationDate',
                                    header: _('Fecha de Creación'),
                                    width: 150,
                                    format: dateFormat, // Format for creation date
                                },
                                { id: 'ProviderName', header: _('Proveedor'), width: 150 }, // Column for Provider
                                { id: 'ProductName', header: _('Producto de Pago'), width: 150 }, // Column for Payment Product
                                { id: 'FranchiseName', header: _('Franquicia'), width: 180 }, // Column for Franchise
                                {
                                    id: 'Amount',
                                    header: _('Valor'),
                                    width: 110,
                                    format: webix.i18n.priceFormat, // Format for Amount
                                    exportType: 'number',
                                    footer: { content: 'summColumn' },
                                },
                                {
                                    id: 'Commission',
                                    header: _('Comisión'),
                                    width: 110,
                                    format: webix.i18n.priceFormat, // Format for Commission
                                    exportType: 'number',
                                },
                                {
                                    id: 'DepositTax',
                                    header: _('Impuesto Deposito'),
                                    width: 130,
                                    format: webix.i18n.priceFormat, // Format for Tax
                                    exportType: 'number',
                                },
                                {
                                    id: 'ModificationDate',
                                    header: _('Modificado'),
                                    width: 150,
                                    format: dateFormat, // Format for Modified Date
                                },
                                {
                                    id: 'Status',
                                    header: _('Estado'),
                                    width: 110,
                                    options: [
                                        { id: '', value: _('None') }, // Options for Status
                                        { id: 'A', value: _('Pagada') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivo') },
                                        { id: 'E', value: _('Enviada') },
                                        { id: 'EX', value: _('Expirada') },
                                        { id: 'R', value: _('Rechazada') },
                                        { id: 'P', value: _('Pendiente') },
                                    ],
                                },
                                { id: 'Notes', header: _('Notas'), width: 150, exportType: 'string' }, // Column for Notes
                                { id: 'ExternalId', header: _('External ID'), width: 150, exportType: 'string' }, // Column for External ID
                                { id: 'IpAddress', header: 'IP', width: 150 }, // Column for IP
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div class='container-preload'><div class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            tooltip: true, // Enable tooltips
                            footer: false, // Footer is toggled on after the first successful load
                            math: true, // Enable math calculations
                            pager: 'pagerFranchiseDetail', // Pager ID
                        },
                    ],
                },
                {
                    view: 'toolbar',
                    id: 'toolbarFranchiseDetail', // Toolbar for the detail view's pagination and export
                    css: 'highlighted_header header6',
                    paddingX: 5,
                    paddingY: 5,
                    height: 40,
                    cols: [
                        {
                            view: 'select', // Dropdown for selecting number of items per page
                            id: 'pageSizeFranchise',
                            options: ['10', '20', '50', '100', '1000', '10000'],
                            width: 90,
                            value: '50',
                            on: {
                                onChange: function () {
                                    $$('datatableFranchiseDetail').getPager().config.size = this.getValue() * 1;
                                    $$('datatableFranchiseDetail').refresh();
                                    $$('datatableFranchiseDetail').scrollTo(100, 0);
                                },
                            },
                        },
                        {
                            view: 'pager', // Pager for navigating through pages
                            id: 'pagerFranchiseDetail',
                            template:
                                '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                            autosize: false,
                            height: 35,
                            size: 50,
                        },
                        {
                            view: 'richselect', // Dropdown for export options
                            name: 'Export',
                            id: 'ExportFranchiseDetail',
                            width: 120,
                            placeholder: _('Exportar'),
                            options: [
                                { id: '1', value: 'Excel' }, // Excel export option
                                { id: '2', value: 'PDF' }, // PDF export option
                            ],
                            on: {
                                onChange: function (value) {
                                    exportTable($$('datatableFranchiseDetail'), value, _('Depósitos por Franquicias'));
                                    $$('ExportFranchiseDetail').setValue('');
                                },
                            },
                        },
                    ],
                },
                {
                    view: 'toolbar',
                    id: 'toolbarFranchiseSummary', // Toolbar for the summary view's export
                    css: 'highlighted_header header6',
                    paddingX: 5,
                    paddingY: 5,
                    height: 40,
                    cols: [
                        {},
                        {
                            view: 'richselect', // Dropdown for export options
                            name: 'Export',
                            id: 'ExportFranchiseSummary',
                            width: 120,
                            placeholder: _('Exportar'),
                            options: [
                                { id: '1', value: 'Excel' }, // Excel export option
                                { id: '2', value: 'PDF' }, // PDF export option
                            ],
                            on: {
                                onChange: function (value) {
                                    exportTable(
                                        $$('datatableFranchiseSummary'),
                                        value,
                                        _('Depósitos por Franquicias'),
                                    );
                                    $$('ExportFranchiseSummary').setValue('');
                                },
                            },
                        },
                    ],
                },
            ],
        };

        // Builds the filename and triggers Excel/PDF export for the given table
        function exportTable(table, value, reportName) {
            const timestamp = new Date()
                .toLocaleString('en-GB', { hour12: true })
                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                .replace(/[\/:]/g, '_')
                .toUpperCase();
            const noData = table.count() > 0 ? '' : _('No hay datos - ');
            const filename = 'Virtualsoft - ' + timestamp + ' - ' + noData + reportName;
            const options = {
                filename: filename,
                ignore: { detailTittle: true },
                footer: false,
                autowidth: true,
            };
            if (value == '1') {
                vthis.app.callEvent('export:data', [{ NameReport: noData + reportName, TypeReport: 'Excel' }]);
                webix.toExcel(table, options);
            } else if (value == '2') {
                vthis.app.callEvent('export:data', [{ NameReport: noData + reportName, TypeReport: 'PDF' }]);
                webix.toPDF(table, options);
            }
        }
    }

    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const multiview = $$('reportMultiviewFranchise'); // Reference to the summary/detail switcher
        const summaryTable = $$('datatableFranchiseSummary'); // Reference to the summary treetable
        const detailTable = $$('datatableFranchiseDetail'); // Reference to the detail datatable
        const summaryColumnIds = ['ProductName', 'TotalDeposits', 'TotalUniqueUsers', 'AmountDeposits'];
        const detailColumnIds = [
            'DepositId',
            'UserId',
            'CreationDate',
            'ProviderName',
            'ProductName',
            'FranchiseName',
            'Amount',
            'Commission',
            'DepositTax',
            'ModificationDate',
            'Status',
            'Notes',
            'ExternalId',
            'IpAddress',
        ];

        [summaryTable, detailTable].forEach((table) => webix.extend(table, webix.OverlayBox));
        summaryColumnIds.forEach((id) => summaryTable.hideColumn(id));
        detailColumnIds.forEach((id) => detailTable.hideColumn(id));
        $$('toolbarFranchiseDetail').hide();
        let columnsRevealed = false;

        
        this.on(this.app, 'depositReportFranchise:filter', (filterData) => {
            const payload = buildRequestPayload(filterData);
            const isDetail = payload.ViewMode === 'DETAIL';

            multiview.setValue(isDetail ? 'datatableFranchiseDetail' : 'datatableFranchiseSummary'); // Show the matching view
            $$('toolbarFranchiseSummary')[isDetail ? 'hide' : 'show'](); // Toggle the summary toolbar
            $$('toolbarFranchiseDetail')[isDetail ? 'show' : 'hide'](); // Toggle the detail toolbar
            const table = isDetail ? detailTable : summaryTable;
            table.clearAll(); // Clear previous data
            table.showOverlay(
                "<div class='container-preload'><div class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
            );

            // POST with a JSON body 
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'Financial/GetFranchisesRequestReport', JSON.stringify(payload), {
                    error: function () {
                        table.hideOverlay();
                        webix.message({
                            title: _('¡Error!'),
                            type: 'alert-error',
                            text: _('No se pudo consultar el reporte. Intente nuevamente.'), // Network/transport failure message
                        });
                    },
                    success: function (text) {
                        table.hideOverlay();
                        const resp = JSON.parse(text); // Parse response
                        if (resp.HasError) {
                            webix.message({
                                title: '¡Mensaje!',
                                type: 'alert-error',
                                text: _(resp.AlertMessage || 'No se pudo consultar el reporte.'), // Business error message from the backend
                            });
                            return;
                        }
                        if (!columnsRevealed) {
                            summaryColumnIds.forEach((id) => summaryTable.showColumn(id));
                            detailColumnIds.forEach((id) => detailTable.showColumn(id));
                            summaryTable.define('footer', true);
                            detailTable.define('footer', true);
                            columnsRevealed = true;
                        }
                        table.parse(resp.data || []);
                        if (typeof resp.total_count === 'number' && resp.total_count > payload.count) {
                            webix.message({
                                type: 'info',
                                text: _('Se muestran los primeros') + ' ' + payload.count + ' ' + _('resultados de') + ' ' + resp.total_count + '. ' + _('Refine los filtros para acotar la búsqueda.'),
                            });
                        }
                        
                        if (!isDetail) {
                            // Level 3 (innermost): one group per franchise, rows below are its payment products
                            summaryTable.data.group({
                                by: 'FranchiseName',
                                map: {
                                    FranchiseId: ['FranchiseId'],
                                    Partner: ['Partner'],
                                    Country: ['Country'],
                                    CountryIcon: ['CountryIcon'],
                                    TotalDeposits: ['TotalDeposits', 'sum'],
                                    AmountDeposits: ['AmountDeposits', 'sum'],
                                    TotalUniqueUsers: ['TotalUniqueUsers', 'sum'],
                                },
                            });
                            // Level 2: franchises grouped by country, with the country flag icon
                            summaryTable.data.group({
                                by: function (obj) {
                                    return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country;
                                },
                                map: {
                                    Partner: ['Partner'],
                                    Country: ['Country'],
                                    CountryIcon: ['CountryIcon'],
                                    TotalDeposits: ['TotalDeposits', 'sum'],
                                    AmountDeposits: ['AmountDeposits', 'sum'],
                                    TotalUniqueUsers: ['TotalUniqueUsers', 'sum'],
                                },
                            });
                            // Level 1 (root): countries grouped by partner, with the partner icon
                            summaryTable.data.group({
                                by: function (obj) {
                                    return "<i class='partner " + obj.Partner + "'></i>";
                                },
                                map: {
                                    TotalDeposits: ['TotalDeposits', 'sum'],
                                    AmountDeposits: ['AmountDeposits', 'sum'],
                                    TotalUniqueUsers: ['TotalUniqueUsers', 'sum'],
                                },
                            });
                        }
                        if (table.count() === 0) {
                            table.showOverlay(
                                "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                    _('No hay datos') +
                                    '</div>', // Show no data overlay
                            );
                        } else {
                            table.hideOverlay();
                        }
                    },
                });
        });

        
        function buildRequestPayload(filterData) {
            const payload = {
                // 'ALL' is the "Todos" option in the filter; the backend expects null for it
                Status: filterData.Status && filterData.Status !== 'ALL' ? filterData.Status : null,
                start: 0, // Pagination offset
                count: 10000, // Pagination page size
            };

            // Datepicker is a day range, Date is a single day; only one is active at a time
            if (filterData.Datepicker) {
                const dates = filterData.Datepicker.split(' - ');
                payload.DateFrom = dates[0] + ' 00:00:00'; // Add dateFrom filter
                payload.DateTo = dates[1] + ' 23:59:59'; // Add dateTo filter
            } else if (filterData.Date) {
                const date = filterData.Date.replace(' 00:00:00', '');
                payload.DateFrom = date + ' 00:00:00'; // Add dateFrom filter
                payload.DateTo = date + ' 23:59:59'; // Add dateTo filter
            }

            if (filterData.FranchiseId !== undefined && filterData.FranchiseId !== '') {
                payload.FranchiseId = Number(filterData.FranchiseId); // Franchise filter
            }
            if (filterData.PaymentProviderId !== undefined && filterData.PaymentProviderId !== '') {
                payload.PaymentProviderId = Number(filterData.PaymentProviderId); // Payment provider filter
            }
            if (filterData.PaymentProductId !== undefined && filterData.PaymentProductId !== '') {
                payload.PaymentProductId = Number(filterData.PaymentProductId); // Payment product filter
            }
            if (filterData.UserId !== undefined && filterData.UserId !== '') {
                payload.UserId = Number(filterData.UserId); // User id filter
            }
            if (filterData.ViewMode) {
                payload.ViewMode = filterData.ViewMode; // SUMMARY or DETAIL
            }
            if (filterData.MinAmount !== undefined && filterData.MinAmount !== '') {
                payload.MinAmount = Number(filterData.MinAmount); // Minimum amount filter
            }
            if (filterData.MaxAmount !== undefined && filterData.MaxAmount !== '') {
                payload.MaxAmount = Number(filterData.MaxAmount); // Maximum amount filter
            }
            if (filterData.IpAddress) {
                payload.IpAddress = filterData.IpAddress; // IP address filter
            }
            if (filterData.SortBy) {
                payload.SortBy = filterData.SortBy; // Sort field
            }
            if (filterData.SortMode) {
                payload.SortMode = filterData.SortMode; // Sort direction
            }

            return payload;
        }
    }
}

// FILE DOCUMENTED
